/*
   ****** The below React component is developed by AECS Private Limited. ******
   Please don't remove, replace, or edit this header information
   Component: <PotAlarms.js>
   Description: This React component handles the display of all pot alarms data status. It will show all the pot alarms level data.
   Dependencies: This component uses Material-UI components, moment for date formatting, and custom components like Header, Footer, and Sidebar.
*/
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Map.css";
import {
  ContentContainer,
  MainContent,
  CenteredCard,
  StyledTableContainer,
  StyledTableHead,
  StyledTableColumn,
  StyledTableCell,
  RefreshIcon,
  CustomTextField,
  HeaderTitle,
} from "../Styles/PotAlarms";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLogoTitle } from "../classes/LogoTitleContext";
import Header from "../Parts/Header";
import Footer from "../Parts/Footer";
import Sidebar from "../Parts/Sidebar";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Radio, RadioGroup, FormControlLabel, Switch } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormGroup from "@mui/material/FormGroup";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import pdfIcon from "../Images/pdf-icon.svg";
import excelIcon from "../Images/excel-icon.svg";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import getAuthHeaders from "../Auth/Authentication";
import refreshIcon from "../Images/refresh-icon.svg";
import { API_ENDPOINTS } from "../Auth/apiConfig";
import dayjs from "dayjs";
import moment from "moment";
import { format } from "date-fns";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const PotAnalytics = ({ onLogout, userData, loggedInUser }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState();
  const [username, setUsername] = useState();
  const [userRole, setUserRole] = useState("");
  const { logoUrl, projectTitle } = useLogoTitle();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedDPs, setSelectedDPs] = useState([]);
  const [selectedVPs, setSelectedVPs] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [selectedParameters, setSelectedParameters] = useState([]);
  const [loading, setLoading] = useState(false);
  //const [rowsPerPage, setRowsPerPage] = useState(10);
  const [potOptions, setPotOptions] = useState([]);
  const [vaccumAlarmsOptions, setvacuumAlarmsOptions] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableDataTwo, setTableDataTwo] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const today = new Date(); // today's date
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 15;
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [sortConfigTwo, setSortConfigTwo] = useState({
    key: null,
    direction: "asc",
  });

  const sortedTableDataTwo = useMemo(() => {
    let sortableData = [...tableDataTwo];
    if (sortConfig.key !== null) {
      sortableData.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];

        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [tableDataTwo, sortConfig]);

  const sortedTableData = useMemo(() => {
    let sortableData = [...tableData];
    if (sortConfigTwo.key !== null) {
      sortableData.sort((a, b) => {
        const aVal = a[sortConfigTwo.key];
        const bVal = b[sortConfigTwo.key];

        if (aVal < bVal) return sortConfigTwo.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfigTwo.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [tableData, sortConfigTwo]);

  // Calculate the index range for the current page
  const startRowIndex = (currentPage - 1) * rowsPerPage;
  const endRowIndex = startRowIndex + rowsPerPage;

  // Paginate the data
  const paginatedDataOne = sortedTableDataTwo.slice(startRowIndex, endRowIndex);
  const paginatedDataTwo = sortedTableData.slice(startRowIndex, endRowIndex);

  // Handle page change event
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const notify = (message) =>
    toast.info(message, {
      css: {
        fontSize: "16px",
        "@media (max-width: 600px)": {
          fontSize: "14px",
        },
      },
    });

  const handleClear = () => {
    setTableDataTwo([]);
    setTableData([]);
    setSelectedDPs([]);
    setSelectedDateFrom(null);
    setSelectedDateTo(null);
  };

  const handleClearTableTwo = () => {
    setTableDataTwo([]);
  };

  const handleClearTableOne = () => {
    setTableData([]);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-"; // Handle falsy values

    let datePart;

    // Check if the dateString contains time (e.g., '2024-12-04 12:34:56' or '2024-12-04T12:34:56Z')
    if (dateString.includes("T")) {
      // For ISO format like 'YYYY-MM-DDTHH:MM:SSZ'
      datePart = dateString.split("T")[0];
    } else {
      // Otherwise, assume 'DD-MM-YYYY' or similar
      datePart = dateString.split(" ")[0]; // Extract the date part before space or 'T'
    }

    const [year, month, day] = datePart.split("-"); // Split into year, month, day

    return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`; // Format as DD/MM/YYYY
  };

  const formatTime = (dateString) => {
    if (!dateString) return ""; // Return an empty string if the dateString is falsy

    let timePart;

    // Check if the dateString contains time (e.g., '2024-12-04T12:34:56Z' or '2024-12-04 12:34:56')
    if (dateString.includes("T")) {
      // For ISO format like '2024-12-04T12:34:56Z'
      timePart = dateString.split("T")[1]?.split("Z")[0]; // Remove the 'Z' if it exists
    } else {
      // Otherwise, extract the time part (for 'DD-MM-YYYY HH:MM:SS' format)
      const parts = dateString.split(" ");
      timePart = parts.length > 1 ? parts[1] : "";
    }

    if (!timePart) return ""; // Return an empty string if no time part exists

    // Remove milliseconds by splitting at '.' and taking the first part (HH:MM:SS)
    const [hours, minutes, seconds] = timePart.split(":");
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:${
      seconds?.split(".")[0].padStart(2, "0") || "00"
    }`; // Ensure HH:MM:SS
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
    });

    // Function to generate table content
    const generateTableContent = (tableData, columns, startY) => {
      const rows = tableData.map((row) => {
        return columns.map((column) => {
          switch (column.key) {
            case "POT":
              return row.POT || "0";
            case "ADDRSTREET":
              return row.ADDRSTREET || " ";
            case "ALARM":
              return row.ALARM === "FLOAT ALARM"
                ? "Float"
                : row.ALARM === "VALVE ALARM"
                ? "Valve"
                : row.ALARM || "0";
            case "STARTDATE":
              return formatDate(row.TIME) || "-";
            case "STARTTIME":
              return formatTime(row.TIME) || "-";
            case "STATUS":
              return row.STATUS || "0";
            case "STOPDATE":
              return formatDate(row.LASTTIME) || "-";
            case "STOPTIME":
              return formatTime(row.LASTTIME) || "-";
            default:
              return "";
          }
        });
      });

      // Add a smaller space after each table
      doc.autoTable({
        head: [columns.map((column) => column.label)],
        body: rows,
        startY: startY,
        headStyles: {
          fillColor: [200, 200, 200], // Grey color (RGB: 169, 169, 169)
          textColor: [0, 0, 0], // Text color (black)
          fontSize: 12, // Font size for header text
          fontStyle: "bold", // Font style for header text
        },
        theme: "striped", // Optional: Adds alternating row colors
      });

      return doc.autoTable.previous.finalY + 10; // Adjust this value as needed
    };

    // Add Title
    const title = "Pot alarm report";
    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const pageWidth = doc.internal.pageSize.width;
    const xTitle = (pageWidth - titleWidth) / 2;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text(title, xTitle, 20);

    // Add Project Name below the title
    const projectName = `Project name: ${
      loggedInUser && loggedInUser.project_description
    }`;
    const projectNameWidth =
      (doc.getStringUnitWidth(projectName) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const xProjectName = (pageWidth - projectNameWidth) / 2;
    doc.text(projectName, xProjectName, 30);

    // Add From Date below the Project Name
    const currentDate = moment().format("DD-MM-YYYY");
    const sevenDaysAgo = moment().subtract(7, "days").format("DD-MM-YYYY");
    const thirtyDaysAgo = moment().subtract(30, "days").format("DD-MM-YYYY");
    let fromDateText;
    if (tableDataTwo.length > 0) {
      fromDateText = `Date between: ${
        selectedDateFrom
          ? format(selectedDateFrom, "dd-MM-yyyy")
          : thirtyDaysAgo
      } / ${
        selectedDateTo ? format(selectedDateTo, "dd-MM-yyyy") : currentDate
      }`;
    } else {
      fromDateText = `Date between: ${
        selectedDateFrom ? format(selectedDateFrom, "dd-MM-yyyy") : sevenDaysAgo
      } / ${
        selectedDateTo ? format(selectedDateTo, "dd-MM-yyyy") : currentDate
      }`;
    }
    const fromDateWidth =
      (doc.getStringUnitWidth(fromDateText) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const xFromDate = (pageWidth - fromDateWidth) / 2;
    doc.text(fromDateText, xFromDate, 40);

    // Starting y-position for the first table
    let startY = 50;

    // Generate PDF content based on each table
    if (tableData.length > 0) {
      const columns1 = [
        { key: "POT", label: "Name" },
        { key: "ADDRSTREET", label: "Location" },
        { key: "ALARM", label: "Type" },
        { key: "STARTDATE", label: "Start date" },
        { key: "STARTTIME", label: "Start time" },
        { key: "STOPDATE", label: "Stop date" },
        { key: "STOPTIME", label: "Stop time" },
      ];
      startY = generateTableContent(tableData, columns1, startY);
    }

    // Generate PDF content based on each table
    if (tableDataTwo.length > 0) {
      const columns2 = [
        { key: "POT", label: "Name" },
        { key: "ADDRSTREET", label: "Location" },
        { key: "ALARM", label: "Type" },
        { key: "STARTDATE", label: "Start date" },
        { key: "STARTTIME", label: "Start time" },
      ];
      startY = generateTableContent(tableDataTwo, columns2, startY);
    }

    // Save the PDF
    doc.save("pot_alarm_report.pdf");
  };

  const handleDownloadExcel = () => {
    const XLSX = require("xlsx");
    const wb = XLSX.utils.book_new();
    const wsData = [];
    const currentDate = moment().format("DD-MM-YYYY");
    const sevenDaysAgo = moment().subtract(7, "days").format("DD-MM-YYYY");
    const thirtyDaysAgo = moment().subtract(30, "days").format("DD-MM-YYYY");

    // Header lines
    const headerLines = [
      ["Pot Alarm Report"],
      [`Project Name: ${loggedInUser && loggedInUser.project_description}`],
    ];

    // Conditional logic for the date text
    let fromDateText;
    if (tableDataTwo.length > 0) {
      fromDateText = `Date between: ${
        selectedDateFrom
          ? format(selectedDateFrom, "dd-MM-yyyy")
          : thirtyDaysAgo
      } / ${
        selectedDateTo ? format(selectedDateTo, "dd-MM-yyyy") : currentDate
      }`;
    } else {
      fromDateText = `Date between: ${
        selectedDateFrom ? format(selectedDateFrom, "dd-MM-yyyy") : sevenDaysAgo
      } / ${
        selectedDateTo ? format(selectedDateTo, "dd-MM-yyyy") : currentDate
      }`;
    }

    // Add the fromDateText to the headerLines array
    headerLines.push([fromDateText]);

    // Push headerLines to wsData
    wsData.push(...headerLines);

    // Function to generate Excel content for a specific data set
    const generateExcelContent = (data, columns) => {
      const header = columns.map((column) => column.label);
      const rows = data.map((row) =>
        columns.map((column) => {
          switch (column.key) {
            case "POT":
              return row.POT || "0";
            case "ADDRSTREET":
              return row.ADDRSTREET || " ";
            case "ALARM":
              return row.ALARM === "FLOAT ALARM"
                ? "Float"
                : row.ALARM === "VALVE ALARM"
                ? "Valve"
                : row.ALARM || "0";
            case "STARTDATE":
              return formatDate(row.TIME) || "-";
            case "STARTTIME":
              return formatTime(row.TIME) || "-";
            case "STATUS":
              return row.STATUS || "0";
            case "STOPDATE":
              return formatDate(row.LASTTIME) || "-";
            case "STOPTIME":
              return formatTime(row.LASTTIME) || "-";
            default:
              return "";
          }
        })
      );

      // Add empty row for spacing
      rows.push(Array(header.length).fill(""));

      return [header, ...rows];
    };

    // Generate PDF content based on each table
    if (tableData.length > 0) {
      const columns1 = [
        { key: "POT", label: "Name" },
        { key: "ADDRSTREET", label: "Location" },
        { key: "ALARM", label: "Type" },
        { key: "STARTDATE", label: "Start date" },
        { key: "STARTTIME", label: "Start time" },
        { key: "STOPDATE", label: "Stop date" },
        { key: "STOPTIME", label: "Stop time" },
      ];
      wsData.push(...generateExcelContent(tableData, columns1));
    }

    // Generate PDF content based on each table
    if (tableDataTwo.length > 0) {
      const columns2 = [
        { key: "POT", label: "Name" },
        { key: "ADDRSTREET", label: "Location" },
        { key: "ALARM", label: "Type" },
        { key: "STARTDATE", label: "Start date" },
        { key: "STARTTIME", label: "Start time" },
      ];
      wsData.push(...generateExcelContent(tableDataTwo, columns2));
    }

    // Create a single worksheet from all data
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Set column widths and style for centered alignment
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const colWidth =
        wsData.reduce((acc, row) => Math.max(acc, `${row[C]}`.length), 0) + 3;
      ws["!cols"] = ws["!cols"] || [];
      ws["!cols"][C] = {
        wch: colWidth,
        s: { alignment: { horizontal: "center" } },
      };
    }

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "PotAla");

    // Save the Excel file
    XLSX.writeFile(wb, "pot_alarm_report.xlsx");
  };

  const handleDP = (event) => {
    const { value } = event.target;

    if (value.includes("Select All")) {
      if (selectedDPs.includes("Select All")) {
        // If "Select All" is already selected, deselect all
        setSelectedDPs([]);
      } else {
        // If "Select All" is not selected, select all items
        setSelectedDPs(potOptions);
      }
    } else if (selectedDPs.includes("Select All")) {
      // If "Select All" was previously selected and now some items are deselected
      setSelectedDPs(value.filter((val) => val !== "Select All"));
    } else {
      // Normal selection behavior
      setSelectedDPs(value);
    }
  };

  const handleRemoveSelectedDP = (valueToRemove) => {
    setSelectedDPs((prevSelected) =>
      prevSelected.filter((value) => value !== valueToRemove)
    );
  };

  const handleLevels = (event) => {
    const { value } = event.target;
    setSelectedLevels(value);
  };

  const handleParameters = (event) => {
    const { value } = event.target;
    setSelectedParameters(value);
  };

  const [selectedDateFrom, setSelectedDateFrom] = useState(null);

  const handleDateFrom = (date) => {
    setSelectedDateFrom(date);
  };

  const [selectedDateTo, setSelectedDateTo] = useState(null);

  const handleDateTo = (date) => {
    setSelectedDateTo(date);
  };

  /*
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
    };
    */

  const handleDefaultGenerate = async () => {
    setLoading(true);
    handleClearTableTwo();

    // Get current date and date 7 days ago
    const currentDate = moment().format("YYYY-MM-DD");
    const sevenDaysAgo = moment().subtract(7, "days").format("YYYY-MM-DD");

    const params = {
      selectedDPs: potOptions,
      selectedDateFrom: sevenDaysAgo, // 7 days ago
      selectedDateTo: currentDate, // Current date
      IntTimeDiff: loggedInUser.TimeDiff,
      IntProjectId: loggedInUser.Projectid,
      clientId: loggedInUser.clientId,
    };

    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.post(
        `${API_ENDPOINTS.potAlarmshandlesearch}`,
        params,
        {
          headers: authHeaders,
        }
      );
      setTableData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    setLoading(true);
    handleClearTableTwo();

    const params = {
      selectedDPs,
      selectedDateFrom: selectedDateFrom
        ? format(selectedDateFrom, "yyyy-MM-dd")
        : null,
      selectedDateTo: selectedDateTo
        ? format(selectedDateTo, "yyyy-MM-dd")
        : null,
      IntTimeDiff: loggedInUser.TimeDiff,
      IntProjectId: loggedInUser.Projectid,
      clientId: loggedInUser.clientId,
    };
    //console.log('Search Parameters:', params);
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.post(
        `${API_ENDPOINTS.potAlarmshandlesearch}`,
        params,
        {
          headers: authHeaders,
        }
      );
      //console.log('Request URL For Alarm Search Load:', response.config.url);
      //console.log('Response Data For Alarm Search Load:', response.data);
      setTableData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataselectpotdata = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(
        `${API_ENDPOINTS.selectpotdata}?Projectid=${loggedInUser.Projectid}`,
        {
          headers: authHeaders,
        }
      );
      const potData = response.data.map((item) => item.pot);
      //console.log('Response Data fetchDataselectpotdata:', response.data);
      setPotOptions(potData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataAlarmPreLoad = async () => {
    setLoading(true);
    handleClearTableOne();
    const params = {
      IntTimeDiff: loggedInUser.TimeDiff,
      IntProjectId: loggedInUser.Projectid,
      clientId: loggedInUser.clientId,
    };
    //console.log('Request parameters:', params);
    try {
      const authHeaders = getAuthHeaders();
      const response = await axios.get(`${API_ENDPOINTS.potalarmpreload}`, {
        params: params,
        headers: authHeaders,
      });
      //console.log('Response Data:', response.data);
      const data = Array.isArray(response.data) ? response.data : [];
      setTableDataTwo(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataselectpotdata();
    fetchDataAlarmPreLoad();
  }, [loggedInUser]);

  const toggleVisibility = (event) => {
    setIsVisible(event.target.checked);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const handleSortTwo = (key) => {
    let direction = "asc";
    if (sortConfigTwo.key === key && sortConfigTwo.direction === "asc") {
      direction = "desc";
    }
    setSortConfigTwo({ key, direction });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div style={{ backgroundColor: "#EBEFF3" }}>
        <Sidebar loggedInUser={loggedInUser} />
        <Header
          logoUrl={logoUrl}
          loggedInUser={loggedInUser}
          onLogout={onLogout}
          username={username}
          userRole={userRole}
        />
        <ContentContainer>
          <MainContent>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} lg={20}>
                <CenteredCard>
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <Box>
                        <HeaderTitle>Pot Alarms</HeaderTitle>
                        <Typography
                          variant="body2"
                          component="a"
                          onClick={handleDefaultGenerate}
                          href="#"
                          sx={{
                            display: "block",
                            mt: 1,
                            color: "dodgerblue",
                            textDecoration: "none",
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                        >
                          Generate Default Report
                          <Typography
                            component="span"
                            sx={{
                              color: "dodgerblue", // Warm orange for contrast
                              fontSize: "0.85rem",
                              fontWeight: "500", // Semi-bold for a refined look
                              ml: 0.5,
                            }}
                          >
                            (Last 7 days)
                          </Typography>
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isVisible}
                                onChange={toggleVisibility}
                                color="primary"
                              />
                            }
                            label={isVisible ? "" : ""}
                          />
                        </FormGroup>
                        <Box sx={{ ml: 1 }}>
                          <RefreshIcon
                            title="Refresh"
                            src={refreshIcon}
                            label="Click to refresh"
                            alt="Refresh"
                            onClick={() => window.location.reload()}
                            sx={{ cursor: "pointer" }} // Add pointer cursor for better UX
                          />
                        </Box>
                      </Box>
                    </Box>
                    {isVisible && (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={2.5}>
                          <FormGroup>
                            <FormControl
                              variant="standard"
                              sx={{ width: "100%" }}
                            >
                              <InputLabel id="dp-select-label">
                                Select pot alarms
                              </InputLabel>
                              <Select
                                multiple
                                value={selectedDPs}
                                onChange={handleDP}
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {selected.length > 0 ? (
                                      selected.length === potOptions.length ? (
                                        <Typography
                                          variant="body2"
                                          color="textSecondary"
                                        >
                                          All pot alarms selected
                                        </Typography>
                                      ) : selected.length > 5 ? (
                                        <Typography
                                          variant="body2"
                                          color="textSecondary"
                                        >
                                          {selected.length} pot alarms selected
                                        </Typography>
                                      ) : (
                                        selected.map((value) => (
                                          <Typography
                                            key={value}
                                            variant="body2"
                                            color="textSecondary"
                                          >
                                            {value}
                                          </Typography>
                                        ))
                                      )
                                    ) : (
                                      <em style={{ color: "#808080" }}>
                                        Select Pots
                                      </em>
                                    )}
                                  </Box>
                                )}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 300,
                                    },
                                  },
                                }}
                              >
                                <MenuItem key="Select All" value="Select All">
                                  Select All
                                </MenuItem>
                                {potOptions.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <FormGroup>
                            <FormControl
                              variant="standard"
                              sx={{ width: "100%" }}
                            >
                              <DatePicker
                                label="Select From"
                                value={selectedDateFrom}
                                onChange={handleDateFrom}
                                minDate={thirtyDaysAgo}
                                maxDate={today}
                                renderInput={(params) => (
                                  <CustomTextField {...params} />
                                )}
                                inputFormat="dd/MM/yyyy"
                                sx={{
                                  width: "100%",

                                  "& .MuiInputLabel-root": {
                                    fontSize: "0.85rem",
                                  },
                                  "& .MuiInputBase-root": {
                                    fontSize: "0.85rem",
                                  },
                                }}
                              />
                            </FormControl>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                          <FormGroup>
                            <FormControl
                              variant="standard"
                              sx={{ width: "100%" }}
                            >
                              <DatePicker
                                label="Select To"
                                value={selectedDateTo}
                                onChange={handleDateTo}
                                minDate={selectedDateFrom || thirtyDaysAgo}
                                maxDate={today}
                                renderInput={(params) => (
                                  <CustomTextField {...params} />
                                )}
                                inputFormat="dd/MM/yyyy"
                                sx={{
                                  width: "100%",
                                  marginBottom: "1px",
                                  "& .MuiInputLabel-root": {
                                    fontSize: "0.85rem",
                                  },
                                  "& .MuiInputBase-root": {
                                    fontSize: "0.85rem",
                                  },
                                }}
                              />
                            </FormControl>
                          </FormGroup>
                        </Grid>
                      </Grid>
                    )}

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" }, // Stack elements vertically on small screens
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: { xs: 1, sm: 0 }, // Add some gap between stacked elements
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleSearch}
                        disabled={loading}
                        sx={{
                          marginRight: { xs: 0, sm: "10px" }, // Remove margin on small screens
                          borderRadius: "5px",
                          padding: "2px 6px",
                          fontSize: { xs: "0.65rem", sm: "0.75rem" }, // Smaller font size on mobile
                          width: { xs: "100%", sm: "auto" }, // Full width on mobile
                          "&:hover": {
                            backgroundColor: "#D9FEE5",
                          },
                        }}
                      >
                        {loading ? <CircularProgress size={20} /> : "Search"}
                      </Button>

                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleClear}
                        sx={{
                          marginRight: { xs: 0, sm: "50px" }, // Remove margin on small screens
                          borderRadius: "5px",
                          padding: "2px 6px",
                          fontSize: { xs: "0.65rem", sm: "0.75rem" }, // Smaller font size on mobile
                          width: { xs: "100%", sm: "auto" }, // Full width on mobile
                          "&:hover": {
                            backgroundColor: "#FFCCCB",
                          },
                        }}
                      >
                        Clear
                      </Button>

                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          flexDirection: { xs: "row", sm: "row" },
                        }}
                      >
                        <a
                          href="#"
                          onClick={handleDownloadPDF}
                          style={{ marginRight: "5px" }}
                        >
                          <img
                            src={pdfIcon}
                            alt="PDF"
                            style={{ marginRight: "5px", height: "50px" }}
                          />{" "}
                          {/* Adjusted size for mobile */}
                        </a>

                        <a
                          href="#"
                          onClick={handleDownloadExcel}
                          style={{ marginRight: "10px" }}
                        >
                          <img
                            src={excelIcon}
                            alt="Excel"
                            style={{ marginRight: "5px", height: "50px" }}
                          />{" "}
                          {/* Adjusted size for mobile */}
                        </a>
                      </Box>
                    </Box>
                  </CardContent>
                </CenteredCard>
              </Grid>
            </Grid>

            <Grid item xs={12} lg={20}>
              <CardContent>
                {loading ? (
                  <Box>
                    <Typography></Typography>
                  </Box>
                ) : tableDataTwo.length > 0 ? (
                  <StyledTableContainer>
                    <Box display="flex" justifyContent="flex-end" mb={2}>
                      <Stack spacing={2}>
                        <Pagination
                          count={Math.ceil(tableDataTwo.length / rowsPerPage)}
                          page={currentPage}
                          onChange={handlePageChange}
                          variant="outlined"
                          color="primary"
                        />
                      </Stack>
                    </Box>
                    <Table>
                      <StyledTableHead>
                        <TableRow>
                          <StyledTableColumn onClick={() => handleSort("POT")}>
                            Name
                            {sortConfig.key === "POT" &&
                              (sortConfig.direction === "asc" ? (
                                <ArrowUpwardIcon fontSize="small" />
                              ) : (
                                <ArrowDownwardIcon fontSize="small" />
                              ))}
                          </StyledTableColumn>
                          <StyledTableColumn
                            onClick={() => handleSort("ADDRSTREET")}
                          >
                            Location
                            {sortConfig.key === "ADDRSTREET" &&
                              (sortConfig.direction === "asc" ? (
                                <ArrowUpwardIcon fontSize="small" />
                              ) : (
                                <ArrowDownwardIcon fontSize="small" />
                              ))}
                          </StyledTableColumn>
                          <StyledTableColumn
                            onClick={() => handleSort("ALARM")}
                          >
                            Type
                            {sortConfig.key === "ALARM" &&
                              (sortConfig.direction === "asc" ? (
                                <ArrowUpwardIcon fontSize="small" />
                              ) : (
                                <ArrowDownwardIcon fontSize="small" />
                              ))}
                          </StyledTableColumn>
                          <StyledTableColumn onClick={() => handleSort("TIME")}>
                            Start date
                            {sortConfig.key === "TIME" &&
                              (sortConfig.direction === "asc" ? (
                                <ArrowUpwardIcon fontSize="small" />
                              ) : (
                                <ArrowDownwardIcon fontSize="small" />
                              ))}
                          </StyledTableColumn>
                          <StyledTableColumn onClick={() => handleSort("TIME")}>
                            Start time
                            {sortConfig.key === "TIME" &&
                              (sortConfig.direction === "asc" ? (
                                <ArrowUpwardIcon fontSize="small" />
                              ) : (
                                <ArrowDownwardIcon fontSize="small" />
                              ))}
                          </StyledTableColumn>
                        </TableRow>
                      </StyledTableHead>

                      <TableBody>
                        {paginatedDataOne.map((row, index) => (
                          <TableRow key={index}>
                            <StyledTableCell align="center">
                              {row.POT}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.ADDRSTREET}
                            </StyledTableCell>
                            <StyledTableCell>
                              {row.ALARM === "FLOAT ALARM" ||
                              row.ALARM === "VALVE ALARM" ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    backgroundColor: "#D9534F",
                                    color: "white",
                                    borderRadius: "4px",
                                    padding: "4px 8px",
                                  }}
                                >
                                  {row.ALARM === "FLOAT ALARM"
                                    ? "Float"
                                    : row.ALARM === "VALVE ALARM"
                                    ? "Valve"
                                    : row.ALARM}
                                </div>
                              ) : (
                                row.ALARM
                              )}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.TIME ? formatDate(row.TIME) : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.TIME ? formatTime(row.TIME) : "-"}
                            </StyledTableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </StyledTableContainer>
                ) : tableData.length === 0 ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                    minHeight="200px"
                  >
                    <Typography
                      variant="h6"
                      color="textPrimary"
                      component="p"
                      fontWeight="bold"
                      sx={{ color: "#616161" }}
                    >
                      No open alarms
                    </Typography>
                  </Box>
                ) : null}
              </CardContent>
            </Grid>

            <Grid item xs={12} lg={20}>
              <CardContent>
                {tableData.length > 0 ? (
                  <StyledTableContainer>
                    <Box display="flex" justifyContent="flex-end" mb={2}>
                      <Stack spacing={2}>
                        <Pagination
                          count={Math.ceil(tableData.length / rowsPerPage)}
                          page={currentPage}
                          onChange={handlePageChange}
                          variant="outlined"
                          color="primary"
                        />
                      </Stack>
                    </Box>
                    <Table>
                      <StyledTableColumn onClick={() => handleSortTwo("POT")}>
                        Name
                        {sortConfigTwo.key === "POT" &&
                          (sortConfigTwo.direction === "asc" ? (
                            <ArrowUpwardIcon fontSize="small" />
                          ) : (
                            <ArrowDownwardIcon fontSize="small" />
                          ))}
                      </StyledTableColumn>
                      <StyledTableColumn
                        onClick={() => handleSortTwo("ADDRSTREET")}
                      >
                        Location
                        {sortConfigTwo.key === "ADDRSTREET" &&
                          (sortConfigTwo.direction === "asc" ? (
                            <ArrowUpwardIcon fontSize="small" />
                          ) : (
                            <ArrowDownwardIcon fontSize="small" />
                          ))}
                      </StyledTableColumn>
                      <StyledTableColumn onClick={() => handleSortTwo("ALARM")}>
                        Type
                        {sortConfigTwo.key === "ALARM" &&
                          (sortConfigTwo.direction === "asc" ? (
                            <ArrowUpwardIcon fontSize="small" />
                          ) : (
                            <ArrowDownwardIcon fontSize="small" />
                          ))}
                      </StyledTableColumn>
                      <StyledTableColumn onClick={() => handleSortTwo("TIME")}>
                        Start date
                        {sortConfigTwo.key === "TIME" &&
                          (sortConfigTwo.direction === "asc" ? (
                            <ArrowUpwardIcon fontSize="small" />
                          ) : (
                            <ArrowDownwardIcon fontSize="small" />
                          ))}
                      </StyledTableColumn>
                      <StyledTableColumn onClick={() => handleSortTwo("TIME")}>
                        Start time
                        {sortConfigTwo.key === "TIME" &&
                          (sortConfigTwo.direction === "asc" ? (
                            <ArrowUpwardIcon fontSize="small" />
                          ) : (
                            <ArrowDownwardIcon fontSize="small" />
                          ))}
                      </StyledTableColumn>
                      <StyledTableColumn
                        onClick={() => handleSortTwo("LASTTIME")}
                      >
                        Stop date
                        {sortConfigTwo.key === "LASTTIME" &&
                          (sortConfigTwo.direction === "asc" ? (
                            <ArrowUpwardIcon fontSize="small" />
                          ) : (
                            <ArrowDownwardIcon fontSize="small" />
                          ))}
                      </StyledTableColumn>
                      <StyledTableColumn
                        onClick={() => handleSortTwo("LASTTIME")}
                      >
                        Stop time
                        {sortConfigTwo.key === "LASTTIME" &&
                          (sortConfigTwo.direction === "asc" ? (
                            <ArrowUpwardIcon fontSize="small" />
                          ) : (
                            <ArrowDownwardIcon fontSize="small" />
                          ))}
                      </StyledTableColumn>

                      <TableBody>
                        {paginatedDataTwo.map((row, index) => (
                          <TableRow key={index}>
                            <StyledTableCell align="center">
                              {row.POT}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.ADDRSTREET}
                            </StyledTableCell>
                            <StyledTableCell>
                              {row.ALARM === "FLOAT ALARM" ||
                              row.ALARM === "VALVE ALARM" ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    backgroundColor: "#D9534F",
                                    color: "white",
                                    borderRadius: "4px",
                                    padding: "4px 8px",
                                  }}
                                >
                                  {row.ALARM === "FLOAT ALARM"
                                    ? "Float"
                                    : row.ALARM === "VALVE ALARM"
                                    ? "Valve"
                                    : row.ALARM}
                                </div>
                              ) : (
                                row.ALARM
                              )}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.TIME ? formatDate(row.TIME) : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.TIME ? formatTime(row.TIME) : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.LASTTIME ? formatDate(row.LASTTIME) : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {row.LASTTIME ? formatTime(row.LASTTIME) : "-"}
                            </StyledTableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </StyledTableContainer>
                ) : (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  ></Typography>
                )}
              </CardContent>
            </Grid>
          </MainContent>
        </ContentContainer>
        <Footer />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
        />
        <ToastContainer />
      </div>
    </LocalizationProvider>
  );
};

export default PotAnalytics;